<template>
  <div v-if="!hasPermission('List Plan')">Você não tem permissão para acessar esta página!</div>
  <div v-else>
    <Toolbar>
      <template v-slot:actions>
        <div class="d-flex align-items-center flex-wrap">
          <div class="row">
            <div class="col-md-12">
              <button class="btn btn-sm btn-light-primary me-2" @click="openSubscriptionSettingsModal">
                <i class="bi bi-bell-fill me-2"></i>
                Config. Assinatura
              </button>
              <a target="_blank" :href="'https://subscription.ubbimed.com.br/planos/' + this.place.id_place" class="btn btn-sm btn-primary">
                Página de assinatura
              </a>
            </div>
          </div>
        </div>
      </template>
    </Toolbar>
  <div class="container-xxl">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <div class="d-flex align-items-center position-relative my-1">
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                       fill="none">
                    <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1"
                          transform="rotate(45 17.0365 15.1223)" fill="black"></rect>
                    <path
                      d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                      fill="black"></path>
                  </svg>
              </span>
            <input type="search" v-model="search"
                   class="form-control form-control-solid w-250px ps-14"
                   placeholder="Pesquisar...">
          </div>
        </div>
        <div class="card-toolbar">
          <button class="btn btn-primary" @click="newPlan">
            Criar novo plano
          </button>
        </div>
      </div>
      <div class="card-body py-4">
        <div class="table-responsive">
          <table class="table table-hover table-row-bordered">
            <thead>
            <tr class="fw-bold fs-6 text-muted">
              <th>Nome</th>
              <th>Valor</th>
              <th>Data início</th>
              <th>Nro de assinantes</th>
              <th>Ativo?</th>
              <th class="text-center">Ações</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="plan in plans.data">
              <td class="d-flex align-items-center">
                <div class="d-flex flex-column">
                  <span class="text-gray-800 text-hover-primary mb-1">{{ plan.plan_name }}</span>
                  <span>{{ plan.plan_description }}</span>
                </div>
              </td>
              <td>
                R$ {{ plan.plan_base_price }}
                <span v-if="plan.plan_dependent_price > 0">/ R$ {{plan.plan_dependent_price}}</span>
              </td>
              <td>{{ date(plan.plan_start_at).format('DD/MM/YYYY') }}</td>
              <td>{{ plan.subscribers_count }}</td>
              <td>
                {{ plan.plan_active ? 'Sim' : 'Não' }}
              </td>
              <td class="text-center" style="min-width: 125px;">
                <button class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary me-1 border border-gray-400"
                        type="button" @click="editPlan(plan)"
                        title="Editar assinatura">
                  <i class="bi bi-pen"></i>
                </button>
                <button class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary me-1 border border-gray-400"
                        type="button" @click="deletePlan(plan)"
                        title="Remover plano">
                  <i class="bi bi-trash2"></i>
                </button>
                <router-link class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary me-1 border border-gray-400"
                        :to="'/subscribers?plan_id=' + plan.id_plan"
                        title="Assinantes">
                  <i class="bi bi-check-all"></i>
                </router-link>
                <a v-if="!plan.plan_company" target="_blank" :href="'https://subscription.ubbimed.com.br/planos/' + this.place.id_place + '?plan_id=' + plan.id_plan"
                   class="btn btn-sm btn-primary" title="Página de assinatura desse plano">
                  <i class="bi bi-box-arrow-up-right"></i>
                </a>
              </td>
            </tr>
            </tbody>
          </table>

          <Pagination :data="plans"/>
        </div>
      </div>
    </div>

    <PlanModal
      :plan="selectedPlan"
      @onClose="selectedPlan = null"
      @planSaved="loadPlans"
    />

    <SubscriptionSettings />
  </div>
</div>
</template>

<script>
import http from "../../helpers/http";
import Pagination from "../../components/Pagination";
import str from "../../helpers/str";
import Toolbar from "../../components/layouts/auth/Toolbar.vue";
import PlanModal from "@/views/plan/PlanModal.vue";
import SubscriptionSettings from "@/views/plan/SubscriptionSettings.vue";
import Modal from "@/helpers/modal";
import Alert from "@/helpers/alert";
import Permission from "@/helpers/permission";

export default {
  name: "Plan",
  components: {
    PlanModal,
    SubscriptionSettings,
    Pagination,
    Toolbar,
  },
  data() {
    return {
      modalKey: Date.now().toString(),
      search: '',
      selectedPlan: null,
      plans: [],
    }
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
  },
  mounted() {
    this.resetPage();
    this.loadPlans();
  },
  watch: {
    '$route.query.page'() {
      this.loadPlans();
    },
  },
  methods: {
    date: moment,
    url(path) {
      return str.url(path)
    },
    loadPlans() {
      this.plans = [];
      http.get(`/places/${this.place.id_place}/plans`, {
        params: {
          'page': this.$route.query.page,
          'search': this.search,
          'per_page': 10,
          'with_contract_template': true,
        }
      }).then((response) => {
        this.plans = response.data;
      });
    },
    newPlan() {
      this.selectedPlan = null;
      this.modalKey = Date.now().toString();

      Modal.toggle('#planModal');
    },
    editPlan(selectedPlan) {
      this.modalKey = Date.now().toString();
      this.selectedPlan = selectedPlan;

      Modal.toggle('#planModal');
    },
    deletePlan(plan) {
      Swal.fire({
        title: 'Atenção',
        text: "Tem certeza que deseja remover o plano?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secundary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.delete(`/places/${this.place.id_place}/plans/${plan.id_plan}`).then(() => {
            this.loadPlans();
          }).catch((e) => {
            Alert.error(e.response.data);
          });
        }
      });
    },
    resetPage() {
      const query = {...this.$route.query, page: 1};
      this.$router.push({path: this.$route.path, query});
    },
    hasPermission(permission) {
      return Permission.has(permission);
    },
    openSubscriptionSettingsModal() {
      Modal.toggle('#subscriptionSettingsModal');
    }
  }
}
</script>

<style scoped>

</style>